import stylesheet from "./stylesheet";
import {
    PageContainer,
    Loading
} from "ncore-ui-kit";

const Home = () => {
    return <PageContainer
        isScrollable={false}
        style={[
            stylesheet.container
        ]}
    >
        <Loading/>
    </PageContainer>;
};
export default Home;
